import { useCallback, useEffect, useRef, useState } from "react";
import { ACTIVE, listRevoices } from "@/lib/jammableApi";

/** Voice-change jobs for one song or session; polls every 4 s while any is running.
 *  `onDone(job, fresh)` fires once per finished job (`fresh` = it finished while this page was open). */
export default function useRevoiceJobs(params, onDone) {
  const [jobs, setJobs] = useState([]);
  const seen = useRef(null);
  const done = useRef(onDone);
  done.current = onDone;
  const key = JSON.stringify(params || null);
  const refresh = useCallback(async () => {
    if (!params) return;
    try {
      const r = await listRevoices(params);
      const fresh = seen.current != null;
      seen.current = seen.current || new Set();
      r.jobs.forEach((j) => { if (j.status === "done" && !seen.current.has(j.id) && done.current?.(j, fresh) !== false) seen.current.add(j.id); });
      setJobs(r.jobs);
    } catch { /* keep the last list */ }
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { refresh(); }, [refresh]);
  const running = jobs.some((j) => ACTIVE.includes(j.status));
  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(refresh, 4000);
    return () => clearInterval(id);
  }, [running, refresh]);
  return { jobs, refresh };
}
